/*
  This file loads the Segment IO SDK for FE Apps to
  send tracking data to your Segment account "source"
  https://segment.com/docs/sources/website/analytics.js/quickstart/
*/
function init(writekey) {
  // Make "analytics" SDK available on the window.
  if (typeof window !== 'undefined') {
    /* SEGMENT CODE START */
    /* eslint-disable */
    !(function () {
      var analytics = (window.analytics = window.analytics || [])
      if (!analytics.initialize)
        if (analytics.invoked)
          window.console &&
            console.error &&
            console.error('Segment snippet included twice.')
        else {
          analytics.invoked = !0
          analytics.methods = [
            'trackSubmit',
            'trackClick',
            'trackLink',
            'trackForm',
            'pageview',
            'identify',
            'reset',
            'group',
            'track',
            'ready',
            'alias',
            'debug',
            'page',
            'once',
            'off',
            'on',
          ]
          analytics.factory = function (t) {
            return function () {
              var e = Array.prototype.slice.call(arguments)
              e.unshift(t)
              analytics.push(e)
              return analytics
            }
          }
          for (var t = 0; t < analytics.methods.length; t++) {
            var e = analytics.methods[t]
            analytics[e] = analytics.factory(e)
          }
          analytics.load = function (t, e) {
            var n = document.createElement('script')
            n.type = 'text/javascript'
            n.async = !0
            n.src =
              'https://cdn.segment.com/analytics.js/v1/' +
              t +
              '/analytics.min.js'
            var a = document.getElementsByTagName('script')[0]
            a.parentNode.insertBefore(n, a)
            analytics._loadOptions = e
          }
          analytics.SNIPPET_VERSION = '4.1.0'

          // Initialize and begin to load Segment to the browser.
          analytics.load(writekey)
        }
    })()
    /* eslint-enable */
    /* SEGMENT CODE END */
  }

  // Return promise in
  // case its needed.
  return ready().catch(e => console.warn(e))
}

// Promisified window.analytics.ready() function
// https://segment.com/docs/sources/website/analytics.js/#ready
function ready() {
  return new Promise((resolve, reject) => {
    try {
      if (
        typeof window !== 'undefined' &&
        typeof window.analytics !== 'undefined'
      ) {
        // When ready, resolve.
        window.analytics.ready(() => resolve(window.analytics))
      } else {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject(
          'Segment is not available. Make sure you initialize first and on the client, not the server.'
        )
      }
    } catch (e) {
      reject(e)
    }
  })
}

// https://segment.com/docs/sources/website/analytics.js/#identify
function identify(userId, traits, options, callback) {
  return ready()
    .then(analytics => analytics.identify(userId, traits, options, callback))
    .catch(e => console.warn(e))
}

// https://segment.com/docs/sources/website/analytics.js/#page
function page(category, name, properties, options, callback) {
  return ready()
    .then(analytics =>
      analytics.page(category, name, properties, options, callback)
    )
    .catch(e => console.warn(e))
}

// https://segment.com/docs/sources/website/analytics.js/#track
function track(event, properties, options, callback) {
  return ready()
    .then(analytics => analytics.track(event, properties, options, callback))
    .catch(e => console.warn(e))
}

module.exports = {
  init,
  ready,
  identify,
  page,
  track,
}
